import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_highlighted_text = _resolveComponent("highlighted-text")!
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createBlock(_component_q_radio, _mergeProps({
    val: _ctx.company.dobjId
  }, _ctx.RADIO_PROPS, {
    class: "iuf-radio no-radio",
    modelValue: _ctx.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
    onClick: _ctx.goToCompanyOverview
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_q_icon, {
          name: _ctx.ICONS_NAME.COMPANY_OUTLINE
        }, null, 8, ["name"]),
        _createVNode(_component_highlighted_text, {
          label: _ctx.company.name,
          "text-filter": _ctx.searchInput
        }, null, 8, ["label", "text-filter"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.company['#leads']) + " " + _toDisplayString(_ctx.company['#leads'] === 1 ? _ctx.t('LEAD.LOW.SING') : _ctx.t('LEAD.LOW.PLUR')), 1)
      ])
    ]),
    _: 1
  }, 16, ["val", "modelValue", "onClick"]))
}